import useNotification from 'antd/es/notification/useNotification';
import { useAuth } from 'auth/AuthContext';
import LoginRegisterForm from 'components/forms/LoginRegisterForm';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';

export default function LoginPage() {
  // Hooks
  const { status, login } = useAuth();
  const { t } = useTranslation();
  const [, context] = useNotification();

  const onFinish = async (values: { email: string; password: string }) => {
    await login({ email: values.email, password: values.password });
    posthog.capture('login.completed');
  };

  return (
    <>
      {context}
      <LoginRegisterForm
        title={t('loginRegister.title.login')}
        description=""
        buttonTitle={t('loginRegister.actions.login')}
        onButtonClick={params => onFinish(params)}
        buttonLoading={status === 'loading'}
        mode="login"
        bottomLinkTo="register"
      />
    </>
  );
}
